import { RowComputeParams } from "./types";
import { ColumnTypes } from "components/product-collection/product-collection-views/product-collection-grid-view/product-collection-grid-view-helper";
import { generateMetricColId } from "helpers/metrics/column-formula/ag-grid-helper";
import { getColIdByColType } from "helpers/door-collection";
import memoizeOne from "memoize-one";

export const STORE_WITH_UNITS = (params: RowComputeParams) => {
    const { metricKind, mainRowNodes, mainGridApi, getterParams } = params;
    const colType = getterParams.column.getColDef().type as ColumnTypes;

    /* For all doors only */
    if (colType === ColumnTypes.DoorBulkQuantity) {
        let hasColAnyUnit = false;
        mainRowNodes.forEach((rowNode) => {
            const value = mainGridApi.getValue(getterParams.column.getColId(), rowNode) ?? 0;
            if (value > 0) {
                hasColAnyUnit = true;
            }
        });
        return hasColAnyUnit ? 1 : "";
    }

    /* For Delivery groupings and Total Columns */
    const deliveryIds = getterParams.colDef?.cellRendererParams?.dimensionIds?.[0] ?? [];
    const doorIds = getterParams.colDef?.cellRendererParams?.dimensionIds?.[1] ?? [];

    const breadCrumbsMap = generateBreadCrumbsMap(deliveryIds, doorIds);

    let total = 0;
    breadCrumbsMap.forEach((breadCrumb) => {
        const colId = generateMetricColId(getColIdByColType(ColumnTypes.DoorBulkQuantity, breadCrumb), metricKind);
        const value = getterParams.api.getValue(colId, getterParams.node) ?? 0;
        if (value > 0) {
            total += value;
        }
    });
    return total;
};

export const generateBreadCrumbsMap = memoizeOne((deliveryIds: Array<any> = [], doorIds: Array<any> = []) => {
    const breadCrumbs = [];
    deliveryIds.forEach((deliveryId) => {
        doorIds.forEach((doorId) => {
            breadCrumbs.push([deliveryId, doorId]);
        });
    });
    return breadCrumbs;
});
